import { Component, OnInit, group, Output, EventEmitter } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { AttachmentPointService } from "../../services/attachment-point.service";
import { GroupLight } from "../../models/group";
import { Station } from "../../models/station";
import { CompleterService, CompleterData, CompleterItem } from "ng2-completer";
import { GroupService } from "../../services/group.service";
import { StationService } from "../../services/station.service";
import { AttachmentPoint } from "../../models/attachmentpoint";
import { ToastsManager } from "ng2-toastr";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-attachmentpoints-form",
  templateUrl: "./attachmentpoints-form.component.html",
  styleUrls: ["./attachmentpoints-form.component.css"],
})
export class AttachmentpointsFormComponent implements OnInit {
  attachmentPoint: AttachmentPoint;

  stationId?: number | string;
  bikeName?: string;

  /** Indicates whether we are in creation or update mode */
  creationMode: boolean;

  @Output() onUpdateValidation = new EventEmitter<AttachmentPoint>();
  @Output() onCreateValidation = new EventEmitter<boolean>();

  visibleGroups: GroupLight[];
  visibleStations: Station[];

  constructor(
    public activeModal: NgbActiveModal,
    public apService: AttachmentPointService,
    private groupService: GroupService,
    private stationService: StationService,
    private toast: ToastsManager,
    public translate: TranslateService
  ) {}

  ngOnInit() {
    // load visible groups
    this.groupService.loadVisibleGroups().subscribe((res) => {
      this.visibleGroups = res;
    });

    if (!this.creationMode && this.attachmentPoint.groupId) {
      this.stationId = this.attachmentPoint.stationId;
      this.bikeName = this.attachmentPoint.bikeName;
      this.updateStationsData();
    } else if (this.creationMode) {
      this.attachmentPoint.type = "MECHANICAL";
    }
  }

  changeType(input: string) {
    this.attachmentPoint.type = input;
  }

  onSaveClick() {
    if (this.creationMode) {
      this.apService.post(this.attachmentPoint).subscribe((ap) => {
        this.toast.success(
          this.translate.instant("toast.apcreated"),
          this.translate.instant("toast.success")
        );
        this.activeModal.close();
        this.onCreateValidation.emit(true);
      });
    } else {
      this.apService.put(this.attachmentPoint).subscribe((ap) => {
        this.toast.success(
          this.translate.instant("toast.apupdated"),
          this.translate.instant("toast.success")
        );
        if (ap.group) {
          ap.groupName = ap.group.name;
          ap.group = undefined;
        }

        if (ap.station) {
          ap.stationName = ap.station.name;
          ap.station = undefined;
        }
        this.onUpdateValidation.emit(ap);
        this.activeModal.close();
      });
    }
  }

  changeGroup() {
    this.stationId = "no-station";
    this.changeStation();
    this.updateStationsData();
  }

  changeStation() {
    if (this.stationId === undefined || this.stationId == "no-station") {
      this.attachmentPoint.stationId = undefined;
      this.attachmentPoint.stationName = undefined;
    } else {
      this.attachmentPoint.stationId = this.stationId as number;
    }
  }

  updateStationsData() {
    this.stationService
      .getStationsFromGroup(this.attachmentPoint.groupId)
      .subscribe((stations) => {
        this.visibleStations = stations;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/attachmentpoints/attachmentpoints-form/attachmentpoints-form.component.ts